import React, {useEffect, useMemo, useRef, useState} from "react";
import {Box, Button, Grid, Typography, useMediaQuery} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useDispatch, useSelector} from "react-redux";
import {IAppState} from "../../store/models";
import {isMobile, useMobileOrientation} from "react-device-detect";
import {
    getShelvesData,
    getStoreDataFromKeywords,
    toggleShelvesScreen
} from "../../store/actionsCreator/shelvesScreenActionsCreator";
import {toggleBasket} from "../../store/actionsCreator/controlsActionsCreator";
import {ReactComponent as Basket} from "../../assets/icons/my_list_icon25x25.svg";
import {ReactComponent as SwitchPriceBtn} from "../../assets/icons/dollar_icon.svg";
import {ReactComponent as ProportionateHeightIcon} from "../../assets/store/maximise_icon.svg";
import {ReactComponent as FullHeightIcon} from "../../assets/store/minimise_icon.svg";
import {ReactComponent as BackToFlyerIcon} from "../../assets/icons/left_arrow.svg";
import {ReactComponent as BackToFlyerHebrewIcon} from "../../assets/icons/right_arrow.svg";
import {ReactComponent as CollapseShelvesIcon} from "../../assets/store/collapse-icon.svg";
import {ReactComponent as HebCollapseShelvesIcon} from "../../assets/store/heb_collapse-icon.svg";
import {ReactComponent as ExpandShelvesIcon} from "../../assets/store/expand-icon.svg";
import {
    expandCollapseShelvesInStore,
    findCurrentTranslateLabel,
    getCellProductsWithConvert,
    getCorrectIndexSlideForCategories,
    getPromoDataForSelectedProductWithConvert,
    getTotalItems,
    showHidePricesInStoreShelves,
    timeLog
} from "../../com/globalsFunctions/globalFunctions";
import {
    IFlyerRuntimePageSpotItem, IFlyerRuntimePageSpotPromo,
    IShelvesCategoryTreeChildDto, IShelvesDataDto,
    IShelvesStoreHeightSettings
} from "../../dtos/flyer";
import {PageSpinner} from "../pageSpinner/pageSpinner";
import {InputSearch} from "../../com/inputSearch/inputSearch";
import {ReactComponent as Search} from "../../assets/icons/search_icon.svg";
import {ShelvesMainCategory} from "./shelvesMainCategory";
import {ShelvesSecondaryCategory} from "./shelvesSecondaryCategory";
import {
    getShelfPromoDetailsDataForPopup,
    toggleShelfPromoDetailsPopup
} from "../../store/actionsCreator/shelfPromoActionCreator";
import {ShelvesCategorySelect} from "./shelvesCategorySelect";
import {forOwn} from 'lodash'
import Slider, {Settings} from "react-slick";
import {changeTargetItem, setAddToMyListOneItemData} from "../../store/actionsCreator/addToMyListOneItemActionsCreator";
import tinycolor from "tinycolor2";
import {useHistory} from "react-router-dom";

const useStyles = makeStyles(() => ({
    shelvesScreenBox: (props: any) => ({
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        maxWidth: `100%`,
        height: '100%',
        '& > .MuiButton-root': {
            // minWidth: '20px',
            // height: '40px',
            padding: '5px 5px',
            '&.isActiveActionBtn': {
                backgroundColor: '#ffffff66'
            },
            "& > .MuiTypography-root": {
                color: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
            },
            "& > div > svg": {
                // fill: props.isLightGuiColor ? `#2A2A2A` : `#FFFFFF`,
                '& path': {
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    // stroke: props.primaryColorHex
                },
                '& circle': {
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    // stroke: props.primaryColorHex
                }
            },
            '&:hover': {
                backgroundColor: '#ffffffBF',
                '& > .MuiTypography-root': {
                    color: props.isLightGuiColor ? props.fontsGuiColor : `#000000`,
                },
                '& > svg > path': {
                    fill: props.isLightGuiColor ? props.fontsGuiColor : `#000000`,
                }
            },
        },
        // "& > .slick-slider.slick-initialized > .slick-list > .slick-track": {
        //     display: "flex",
        //     justifyContent: "center",
        // }
    }),
    shelvesScreen: (props: any) => ({
        height: props.isMobileView ? `${document.documentElement.clientHeight - 50}px` : `100%`,
        width: `100vw`,
        backgroundColor: `#ffffff`,
        flexFlow: `column`,
        display: `flex`,
        direction: props.direction,
    }),
    shelvesHeaderForDesktop: (props: any) => ({
        height: `60px`,
        backgroundColor: props.backgroundColor,
        width: `100%`
    }),
    shelvesCategoriesFirstLVL1Wrapper: (props: any) => ({
        // justifyContent: `center`,
        margin: props.isMobileView ? `0 auto` : `0`,
        // maxWidth: `100%`,
        // overflow: `auto`,
        // '&::-webkit-scrollbar-track': {
        //     backgroundColor:` #F5F5F5`,
        // },
        // '&::-webkit-scrollbar': {
        //     width: `2px!important`,
        //     backgroundColor: `#F5F5F5`,
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     // border: `2px solid #555555`,
        //     backgroundColor: `#000000`,
        // },
    }),
    shelvesCategoriesFirstLVL2Wrapper: (props: any) => ({
        height: props.isMobileView ? `40px` : `50px`,
        backgroundColor: `#D6D6D6`
    }),
    logoWrapper: {
        justifyContent: 'flex-start!important',
        "& > img": {
            height: "100%",
            maxHeight: '30px',
            objectFit: `contain`,
            // width: "100%",
            maxWidth: `100%`
        }
    },
    shelvesHeaderButton: (props: any) => ({
        height: `60px!important`,
        '&.MuiButton-root': {
            // padding: '0!important',
            display: `flex`,
            alignItems: 'center',
            flexDirection: `column`,
            textTransform: `capitalize`,
            // minWidth: `50px`,
            '& > .MuiTypography-root': {
                // color: `#ffffff`,
                fontSize: `14px`,
                textOverflow: `ellipsis`,
                overflow: `hidden`,
                whiteSpace: `nowrap`,
                maxWidth: `100%`,
                marginTop: `4px`,
                fontFamily: `${props.fontFamily}`,
            },
            '&:hover': {
                backgroundColor: '#ffffffBF',
                '& > .MuiTypography-root': {
                    color: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                },
                '& svg > path': {
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                }
            },
            '&.Mui-disabled': {
                opacity: `0.5`
            },
        },
    }),
    switcherForPrices: (props: any) => ({
        width: `2.6em!important`,
        height: `2.6em!important`,
        '&.MuiButton-root': {
            padding: `5px`,
            '& > .MuiTypography-root': {
                color: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
            },
            '& svg path': {
                fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                // stroke: props.isLightGuiColor ? `#2A2A2A` : `#FFFFFF`,
            },
            '&:hover': {
                '& svg path': {
                    fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    // stroke: props.isLightGuiColor ? `#2A2A2A` : `#FFFFFF`,
                },
                '& > .MuiTypography-root': {
                    color: props.isLightGuiColor ? props.fontsGuiColor : props.backgroundColor,
                },
            }

        }
    }),
    numberOfMyListItems: (props: any) => ({
        position: `absolute`,
        background: props.backgroundColor,
        color: props.isLightGuiColor ? props.fontsGuiColor : `#ffffff`,
        border: props.isLightGuiColor ? `2px solid ${props.fontsGuiColor}` : `2px solid #ffffff`,
        borderRadius: `5px`,
        width: `30px`,
        top: `-4px`,
        right: `-22px`
    }),
    closeIconWrapper: (props: any) => ({
        display: `flex`,
        justifyContent: `center`,
        '& > .MuiButton-root': {
            '& svg > path': {
                fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
            },
            '&:hover': {
                backgroundColor: '#ffffffBF',
                '& svg > path': {
                    fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                }
            },
            '&:active': {
                backgroundColor: '#ffffffBF',
                '& svg > path': {
                    fill: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                    stroke: props.isLightGuiColor ? props.fontsGuiColor : `#FFFFFF`,
                }
            }
        },
    }),
    shelvesContentWrapper: {
        backgroundColor: `#E5E5E5`
    },
    shelvesSearchBtnWrapper: {
        display: `flex`,
        alignItems: `center`,
        padding: `0 10px`,
        '& .MuiButton-root': {
            width: `24px`,
            height: `24px`,
            padding: `3px`,
            backgroundColor: `#ffffff`,
            border: `1px solid #616161`,
            '& svg path': {
                fill: '#4D4D4D',
                // stroke: '#4D4D4D'
            },
        }
    },
}));

export const ShelvesScreenContent = () => {
    let history = useHistory();
    const urlSearchParams = new URLSearchParams(history.location.search);
    const allSearchParams = Object.fromEntries(urlSearchParams.entries());
    const iframeWrapperRef = useRef(null);
    const dispatch = useDispatch();
    const {isLandscape} = useMobileOrientation();
    const {
        flyersBranch: {data: flyerBranch},
        shelvesScreen,
        storeData: storeGlobalData,
        controlsBranch,
        shelfPromo,
        myListState,
        addToMyListOneItemData,
    } = useSelector((state: IAppState) => state);
    const settingForPopup = storeGlobalData?.isFromFlyer ? flyerBranch : shelvesScreen?.data?.storeSetting;
    const isPriceless = settingForPopup?.typeCode === 3;
    const isLightGuiColor = tinycolor(settingForPopup?.primaryColorRgb || "#C32E43").isLight();
    const fontsGuiColor = settingForPopup?.fontsColorRgb || "#000000";
    const {showBasket, isPortraitView} = controlsBranch;
    const isMobileView = isPortraitView || isMobile;
    const stylesProperties = {
        backgroundColor: settingForPopup?.primaryColorRgb || "#C32E43",
        direction: settingForPopup?.dir?.toLowerCase() || 'ltr',
        fontFamily: settingForPopup?.font?.toLowerCase() || "roboto",
        isMobileView: isMobileView,
        isLightGuiColor: isLightGuiColor,
        fontsGuiColor: fontsGuiColor
    }
    const isHebrewStyle = settingForPopup?.dir?.toLowerCase() === "rtl";
    const classes = useStyles(stylesProperties);
    const myBasketTitle = findCurrentTranslateLabel(137, 'My Basket', settingForPopup);
    const noItemMessageForStore = findCurrentTranslateLabel(651, 'No Items were found', settingForPopup);
    const proportionalHeightTitle = findCurrentTranslateLabel(688, 'Show Items Proportionately', settingForPopup);
    const fullHeightTitle = findCurrentTranslateLabel(687, 'Show Items in Full Size', settingForPopup);
    const showHidePricesTitle = findCurrentTranslateLabel(686, 'Hide/Show Prices', settingForPopup);
    const collapseText = findCurrentTranslateLabel(
        692,
        "Collapse all",
        settingForPopup
    );
    const expandText = findCurrentTranslateLabel(
        693,
        "Expand all",
        settingForPopup
    );
    const promos = myListState.promos;
    const freeItems = myListState.benefitItems;
    const [searchValue, changeSearchValue] = useState<string>('');
    const [isShowSearchInputShelvesScreen, showSearchInputShelvesScreen] = useState<boolean>(false);
    const [localStateOfCategories, setLocalStateOfCategories] = useState<IShelvesCategoryTreeChildDto[] | []>([]);
    const [localStateSecondaryCategoriesFromSelectedMainCategory, setLocalStateSecondaryCategoriesFromSelectedMainCategory] = useState<IShelvesCategoryTreeChildDto[] | []>([]);
    const [store, updateStore] = useState<IShelvesDataDto>({});
    const [isShowPrice, setShowPrice] = useState<boolean>(false);
    const [isCollapsedShelves, setIsCollapsedShelves] = useState<boolean>(false)
    const [heightSettings, setHeightSettings] = useState<IShelvesStoreHeightSettings>({
        isFullHeight: false
    });
    // const [isFullHeight, setIsFullHeight] = useState<boolean>(false);
    // const [isProportionateHeight, setIsProportionateHeight] = useState<boolean>(true);
    const [startTime, setStartedTime] = useState<number>(new Date().getTime());
    const [log, setLog] = useState<any>([]);
    const [responseLog, setResponseLog] = useState<any>([]);
    const mainCategorySlider = useRef(null);
    const secondaryCategorySlider = useRef(null);
    const totalItems = useMemo(() => getTotalItems(promos, freeItems), [promos, freeItems]);
    const xl = useMediaQuery(`(min-width:1536px)`);
    const lg = useMediaQuery(`(min-width:1200px)`)
    const md = useMediaQuery(`(min-width:800px)`)
    const mainCategorySlidesShow = xl ? 7 : lg ? 4 : md ? 2 : 2;
    const secondaryCategorySlidesShow = xl ? 8 : lg ? 5 : md ? 3 : 2;
    let headerSectionPxNumber = 12;
    if (shelvesScreen
        && shelvesScreen.data
        && shelvesScreen.data.canvas
        && shelvesScreen.data.canvas.store
        && shelvesScreen.data.canvas.store.departments
        && shelvesScreen.data.canvas.store.departments[0]
        && shelvesScreen.data.canvas.store.departments[0].sections
        && shelvesScreen.data.canvas.store.departments[0].sections[0]
        && shelvesScreen.data.canvas.store.departments[0].sections[0].displays
        && shelvesScreen.data.canvas.store.departments[0].sections[0].displays[0]
        && shelvesScreen.data.canvas.store.departments[0].sections[0].displays[0].headerAreaPx
        && shelvesScreen.data.canvas.store.departments[0].sections[0].displays[0].headerAreaPx.x
    ) {
        headerSectionPxNumber = Number(shelvesScreen.data.canvas.store.departments[0].sections[0].displays[0].headerAreaPx?.x - 5);
    }

    const mainSettings: Settings = {
        dots: false,
        infinite: false,
        // swipe: true,
        slidesToShow: mainCategorySlidesShow,
        slidesToScroll: mainCategorySlidesShow - 1,
        initialSlide: 0,
        speed: 800,
        // variableWidth: true,
        rtl: isHebrewStyle,
    };


    const secondarySettings: Settings = {
        dots: false,
        infinite: false,
        // swipe: true,
        slidesToShow: secondaryCategorySlidesShow,
        slidesToScroll: secondaryCategorySlidesShow - 1,
        initialSlide: 0,
        speed: 800,
        // variableWidth: true,
        rtl: isHebrewStyle,
    };

    // useEffect(() => {
    //
    // }, [])


    useEffect(() => {
        // setStartedTime(new Date().getTime());
        const timeString = timeLog('Click takes:', startTime);
        setLog([timeString]);
        getStore(isLandscape);
    }, []);


    useEffect(() => {
        const slider = secondaryCategorySlider.current as unknown as Slider as any;
        if (slider) {
            const currentSlideIndex = getCorrectIndexSlideForCategories(slider, secondaryCategorySlidesShow, isHebrewStyle);
            slider.slickGoTo(currentSlideIndex);
        }
        const isSomeOfSecondaryCategoriesAlreadySelected = localStateSecondaryCategoriesFromSelectedMainCategory?.some((secondaryCategory: IShelvesCategoryTreeChildDto) => {
            return secondaryCategory.isSelected
        })
        if (!isSomeOfSecondaryCategoriesAlreadySelected && localStateSecondaryCategoriesFromSelectedMainCategory?.length) {
            onChangeSecondaryCategory();
        }
    }, [localStateSecondaryCategoriesFromSelectedMainCategory])

    useEffect(() => {
        if (shelvesScreen.type === 'GET_SHELVES_DATA_SUCCESS') {
            const timeString = timeLog('Get data from WM:', startTime);
            setLog([...log, timeString]);
            const responseLog: any = [];
            forOwn(shelvesScreen?.data?.diagnostics, function (value, key) {
                responseLog.push(`${key}: ${value}`);
            });
            responseLog.push(`elapsedTimeSecs: ${shelvesScreen?.elapsedTimeSecs}`)
            setResponseLog(responseLog);
            const iframeWrapper = iframeWrapperRef.current as HTMLDivElement | null;
            if (iframeWrapper) {
                iframeWrapper.style.overflowY = 'auto';
            }
        }
    }, [shelvesScreen.type])

    useEffect(() => {
        console.log(shelvesScreen.data);
        // setLocalStateOfCategories(shelvesScreen.data?.categoryTree ? [...shelvesScreen.data?.categoryTree, ...shelvesScreen.data?.categoryTree, ...shelvesScreen.data?.categoryTree,...shelvesScreen.data?.categoryTree] : []);
        const mainCategories = shelvesScreen.data?.categoryTree || [];
        // const mainCategories = (isHebrewStyle && shelvesScreen.data?.categoryTree ? shelvesScreen.data?.categoryTree?.reverse() : shelvesScreen.data?.categoryTree) || [];
        setLocalStateOfCategories(mainCategories);
        updateStore(shelvesScreen.data || {});
    }, [shelvesScreen.data]);

    const onMessageReceivedFromIframe = React.useCallback(
        event => {
            const iframe: any = (document?.querySelector("#storeIframe") as HTMLIFrameElement);
            if (event.data.name === 'openPopupFromProduct') {
                console.log(`openPopupFromProduct`);
                dispatch(toggleShelfPromoDetailsPopup(false));
                // const cellProducts: IShelfItemDto[] = findCellProducts(event.data.json.id, shelvesScreen.data?.canvas?.store);
                const cellProductsWithConvert: IFlyerRuntimePageSpotItem[] = getCellProductsWithConvert(event.data.json.id, shelvesScreen.data?.canvas?.store);
                const currentProduct: IFlyerRuntimePageSpotItem | undefined = cellProductsWithConvert.find((item: IFlyerRuntimePageSpotItem) => {
                    if (item.id === event.data.json.id) {
                        return item;
                    }
                })
                if (currentProduct) {
                    const promoForProduct: IFlyerRuntimePageSpotPromo = getPromoDataForSelectedProductWithConvert(event.data.json.isHasPromos ? event.data.json.promos[0] : null, currentProduct);
                    if (!Boolean(addToMyListOneItemData.data)) {
                        dispatch(setAddToMyListOneItemData(
                            {
                                promoDetails: promoForProduct,
                                targetItem: currentProduct,
                                itemsArray: cellProductsWithConvert
                            },
                            true
                        ))
                    } else {
                        dispatch(changeTargetItem(currentProduct))
                    }
                }

            } else if (event.data.name === 'openPopupFromPromo') {
                dispatch(toggleShelfPromoDetailsPopup(true));
                dispatch(getShelfPromoDetailsDataForPopup(event.data.json.promos[0].id))
            } else if (event.data.name === 'openPopupFromTv') {
                dispatch(toggleShelfPromoDetailsPopup(true));
                dispatch(getShelfPromoDetailsDataForPopup(event.data.json.id))
            } else if (event.data.name === 'iframeReady') {
                if (iframe) {
                    iframe.contentWindow.postMessage({
                        action: "message",
                        data: {
                            ...store,
                            message: noItemMessageForStore,
                            isPriceless,
                            actionName: 'initData',
                        }
                    });
                    const timeString = timeLog('Iframe ready:', startTime);
                    setLog([...log, timeString]);
                }
            }
        },
        [store, addToMyListOneItemData.data]
    );

    useEffect(() => {
        window.addEventListener("message", onMessageReceivedFromIframe, false);
        return () => {
            window.removeEventListener("message", onMessageReceivedFromIframe, false);
        }
    }, [onMessageReceivedFromIframe]);

    useEffect(() => {
        let goToSlideNumber: number = 0;
        if (localStateOfCategories) {
            localStateOfCategories.forEach((selectedMainCategory: IShelvesCategoryTreeChildDto, index: number) => {
                if (selectedMainCategory.isSelected) {
                    // setLocalStateSecondaryCategoriesFromSelectedMainCategory(selectedMainCategory.childCategories ? [...selectedMainCategory.childCategories, ...selectedMainCategory.childCategories, ...selectedMainCategory.childCategories] : []);
                    const childCategories = selectedMainCategory.childCategories || [];
                    // const childCategories = (isHebrewStyle ? selectedMainCategory.childCategories?.reverse() : selectedMainCategory.childCategories) || [];
                    setLocalStateSecondaryCategoriesFromSelectedMainCategory(childCategories);
                    goToSlideNumber = index;
                }
            })
        }
        const mainSlider = mainCategorySlider.current as unknown as Slider as any;
        if (mainSlider) {
            const currentSlideIndex = getCorrectIndexSlideForCategories(mainSlider, mainCategorySlidesShow, isHebrewStyle);
            // mainSlider.slickGoTo((goToSlideNumber));
            mainSlider.slickGoTo(currentSlideIndex);
        }
    }, [localStateOfCategories]);

    useEffect(() => {
        const handler = (e: MediaQueryListEvent) => {
            getStore(!e.matches, searchValue);
        }

        let portrait = window.matchMedia("(orientation: portrait)");

        portrait.addEventListener("change", handler);
        let timeout: any;
        const handleResize = () => {
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                getStore(isLandscape, searchValue);
            }, 1000);
        }
        if(!isMobile){
            window.addEventListener("resize", handleResize);
        }
        return () => {
            window.removeEventListener("resize", handleResize);
            portrait.removeEventListener("change", handler);
        }
    }, [searchValue]);

    const getStore = (isLandscape: boolean, valueForSearch: string = "") => {
        if(valueForSearch !== ""){
            getStoreWithSearchValue(valueForSearch, isLandscape);
            return;
        }

        const viewportHeight = document.getElementById('storeIframe')?.offsetHeight!;
        const viewportWidth = document.getElementById('storeIframe')?.offsetWidth!;
        if (settingForPopup && viewportHeight && viewportWidth) {
            dispatch(getShelvesData(
                shelvesScreen.itemId!,
                viewportHeight,
                viewportWidth,
                isLandscape,
                settingForPopup?.id));
        }

    }

    const getStoreWithSearchValue = (valueForSearch: string = "", isLandscape: boolean = true) => {
        dispatch(getStoreDataFromKeywords(
            valueForSearch,
            settingForPopup?.accountId || 0,
            document.getElementById('storeIframe')?.offsetHeight!,
            document.getElementById('storeIframe')?.offsetWidth!,
            isLandscape,
            heightSettings.isFullHeight,
            null,
        ));

    }

    const onChangeSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        changeSearchValue(e.target.value);
    }

    const onClearSearchInput = () => {
        if (isMobile) {
            showSearchInputShelvesScreen(!isShowSearchInputShelvesScreen);
        }
        changeSearchValue('');
        getStore(isLandscape);
    }

    const onSubmitSearchInput = (e: any) => {
        e.preventDefault();
        if (searchValue === "") {
            getStore(isLandscape);
            return;
        }
        const iframeWrapper = iframeWrapperRef.current as HTMLDivElement | null;
        if (iframeWrapper) {
            iframeWrapper.style.overflowY = 'scroll';
        }

        dispatch(toggleShelfPromoDetailsPopup(false));
        if (Boolean(addToMyListOneItemData.data)) {
            dispatch(setAddToMyListOneItemData(null));
        }
        getStoreWithSearchValue(searchValue, isLandscape);
    }

    const onChangeMainCategory = (targetCategory: IShelvesCategoryTreeChildDto) => {
        if (localStateOfCategories) {
            const customizeStateForMainCategories = [...localStateOfCategories];
            const newStateForMainCategories = customizeStateForMainCategories.map((mainCategory: IShelvesCategoryTreeChildDto) => {
                if (targetCategory.id === mainCategory.id) {
                    mainCategory = {
                        ...mainCategory,
                        isSelected: true,
                    }
                } else {
                    mainCategory = {
                        ...mainCategory,
                        isSelected: false,
                    }
                }
                return mainCategory;
            })
            setLocalStateOfCategories(newStateForMainCategories);
        }
    }

    const onChangeSecondaryCategory = (targetCategory?: IShelvesCategoryTreeChildDto) => {
        if (localStateSecondaryCategoriesFromSelectedMainCategory && allSearchParams.isCaptive !== "true") {
            const customizeStateForMainCategories = [...localStateSecondaryCategoriesFromSelectedMainCategory];
            let newStateForMainCategories = customizeStateForMainCategories.map((secondaryCategory: IShelvesCategoryTreeChildDto, index) => {
                if (index === 0) {
                    secondaryCategory = {
                        ...secondaryCategory,
                        isSelected: true,
                    }
                } else {
                    secondaryCategory = {
                        ...secondaryCategory,
                        isSelected: false,
                    }
                }
                return secondaryCategory;
            });
            if (targetCategory) {
                newStateForMainCategories = customizeStateForMainCategories.map((secondaryCategory: IShelvesCategoryTreeChildDto) => {
                    if (targetCategory?.id === secondaryCategory.id) {
                        secondaryCategory = {
                            ...secondaryCategory,
                            isSelected: true,
                        }
                    } else {
                        secondaryCategory = {
                            ...secondaryCategory,
                            isSelected: false,
                        }
                    }
                    return secondaryCategory;
                })
            }

            const selectedCategory = newStateForMainCategories.find((secondaryCategory: IShelvesCategoryTreeChildDto) => {
                if (secondaryCategory.isSelected) {
                    return secondaryCategory;
                }
            });
            if (settingForPopup && selectedCategory && selectedCategory.id && !isMobileView) {
                dispatch(toggleShelfPromoDetailsPopup(false));
                if (Boolean(addToMyListOneItemData.data)) {
                    dispatch(setAddToMyListOneItemData(null));
                }
                const iframeWrapper = iframeWrapperRef.current as HTMLDivElement | null;
                if (iframeWrapper) {
                    iframeWrapper.style.overflowY = 'scroll';
                }

                dispatch(getShelvesData(
                    selectedCategory.id,
                    document.getElementById('storeIframe')?.offsetHeight!,
                    document.getElementById('storeIframe')?.offsetWidth!,
                    isLandscape,
                    settingForPopup?.id,
                    true, heightSettings.isFullHeight));
            }

            // setLocalStateSecondaryCategoriesFromSelectedMainCategory(newStateForMainCategories);
        }

    }

    const togglePricesForStore = () => {
        setShowPrice(!isShowPrice);
        showHidePricesInStoreShelves();
    }

    const toggleShelvesForStore = () => {
        setIsCollapsedShelves(!isCollapsedShelves);
        expandCollapseShelvesInStore(!isCollapsedShelves);
    }

    const setFullHeightForStore = (e: React.MouseEvent<HTMLButtonElement>) => {
        const name = e.currentTarget.name;
        const isFullHeight = name === 'fullHeight';
        setHeightSettings({
            isFullHeight
        })
        const selectedSecondaryCategory = localStateSecondaryCategoriesFromSelectedMainCategory.find((secondaryCategory: IShelvesCategoryTreeChildDto) => secondaryCategory.isSelected);
        if (selectedSecondaryCategory && selectedSecondaryCategory.id && settingForPopup?.id) {
            dispatch(getShelvesData(
                selectedSecondaryCategory.id,
                document.getElementById('storeIframe')?.offsetHeight!,
                document.getElementById('storeIframe')?.offsetWidth!,
                isLandscape,
                settingForPopup?.id,
                true,
                isFullHeight
            ));
        }
    }

    const onClose = () => {
        dispatch(toggleShelvesScreen(null));
        dispatch(setAddToMyListOneItemData(null));
        dispatch(toggleShelfPromoDetailsPopup(false));
    }

    const secondaryCategoriesComp = useMemo(() => {
        return localStateSecondaryCategoriesFromSelectedMainCategory?.map((secondLvlCategory: IShelvesCategoryTreeChildDto) => {
            if(allSearchParams.isCaptive === "true"){
                if(secondLvlCategory.isSelected){
                    return (
                        <ShelvesSecondaryCategory
                            key={secondLvlCategory.id}
                            category={secondLvlCategory}
                            // onChangeSecondaryCategory={onChangeSecondaryCategory}
                            onChangeSecondaryCategory={onChangeSecondaryCategory}
                        />
                    )
                }
            } else {
                return (
                    <ShelvesSecondaryCategory
                        key={secondLvlCategory.id}
                        category={secondLvlCategory}
                        // onChangeSecondaryCategory={onChangeSecondaryCategory}
                        onChangeSecondaryCategory={onChangeSecondaryCategory}
                    />
                )
            }
        })
    }, [localStateSecondaryCategoriesFromSelectedMainCategory]);
    const mainCategoriesComp = useMemo(() => {
        return localStateOfCategories?.map((firstLvlCategory: IShelvesCategoryTreeChildDto) => {
            if(allSearchParams.isCaptive === "true"){
                if(firstLvlCategory.isSelected){
                    return (
                        <ShelvesMainCategory
                            key={firstLvlCategory.id}
                            category={firstLvlCategory}
                            onChangeMainCategory={onChangeMainCategory}
                            // onChangeMainCategory={() => {}}
                        />
                    )
                }
            } else {
                return (
                    <ShelvesMainCategory
                        key={firstLvlCategory.id}
                        category={firstLvlCategory}
                        onChangeMainCategory={onChangeMainCategory}
                        // onChangeMainCategory={() => {}}
                    />
                )
            }
        })
    }, [localStateOfCategories]);

    const onMyListClick = () => {
        if (shelfPromo.isOpen) {
            dispatch(toggleShelfPromoDetailsPopup(false));
        }
        if (Boolean(addToMyListOneItemData.data)) {
            dispatch(setAddToMyListOneItemData(null));
        }
        if (shelfPromo.isOpen || Boolean(addToMyListOneItemData.data)) {
            dispatch(toggleBasket(true));
        } else {
            dispatch(toggleBasket());
        }
    }

    return (
        <Box className={classes.shelvesScreen}
             sx={{position: (((shelfPromo.isOpen || Boolean(addToMyListOneItemData.data)) && isMobileView) || (showBasket && isMobileView)) ? `fixed` : `relative`}}
        >
            {
                !isMobileView &&
                <Box className={classes.shelvesHeaderForDesktop}>
                    <Grid container alignItems={`center`} sx={{height: `100%`}} columns={16} columnGap={"40px"}>
                        <Grid item xs>
                            <Grid container columnGap={1}>
                                <Grid item xs={4}>
                                    <Box
                                        className={`${classes.closeIconWrapper} ${classes.shelvesScreenBox}`}
                                    >
                                        <Button onClick={onClose} className={classes.shelvesHeaderButton}>
                                            <Box sx={{position: `relative`}} mx={`12px`}>
                                                {
                                                    settingForPopup?.dir?.toLowerCase() === `rtl`
                                                        ?
                                                        <BackToFlyerHebrewIcon style={{width: `25px`, height: `25px`}}/>

                                                        :
                                                        <BackToFlyerIcon style={{width: `25px`, height: `25px`}}/>
                                                }
                                            </Box>
                                        </Button>
                                    </Box>
                                </Grid>
                                <Grid item xs>
                                    <Box className={`${classes.logoWrapper} ${classes.shelvesScreenBox}`}>
                                        <img src={settingForPopup?.logo || ""} alt="Logo"/>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} md={7} lg={9} xl={11} sx={{height: `100%`}}>
                            {
                                shelvesScreen.isDisplayCategories &&
                                <>
                                    {
                                        localStateOfCategories?.length > 0 &&
                                        <Box
                                            className={`${classes.shelvesScreenBox} ${classes.shelvesCategoriesFirstLVL1Wrapper} customScrollBar`}
                                        >
                                            {mainCategoriesComp.length > mainCategorySlidesShow &&
                                                <Slider
                                                    ref={mainCategorySlider}
                                                    {...mainSettings}
                                                >
                                                    {
                                                        mainCategoriesComp
                                                    }
                                                </Slider>
                                            }
                                            {mainCategoriesComp.length <= mainCategorySlidesShow &&
                                                <Box
                                                    sx={{
                                                        display: "flex"
                                                    }}
                                                >
                                                    {mainCategoriesComp}
                                                </Box>
                                            }
                                        </Box>
                                    }
                                </>
                            }
                        </Grid>
                        <Grid item xs>
                            <Grid container>
                                <Grid item xs>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexFlow: "row",
                                            alignItems: "center",
                                            height: "100%",
                                            columnGap: "4px"
                                        }}
                                    >
                                        <Box
                                            className={classes.shelvesScreenBox}
                                            // sx={{justifyContent: `flex-end!important`}}
                                        >
                                            <Button
                                                title={proportionalHeightTitle}
                                                className={`${!heightSettings.isFullHeight ? 'isActiveActionBtn' : ''} ${classes.switcherForPrices}`}
                                                // title={myBasketTitle}
                                                name={"proportionateHeight"}
                                                onClick={setFullHeightForStore}>
                                                <ProportionateHeightIcon/>
                                            </Button>
                                        </Box>
                                        <Box
                                            className={classes.shelvesScreenBox}
                                            // sx={{justifyContent: `flex-end!important`}}
                                        >
                                            <Button
                                                title={fullHeightTitle}
                                                className={`${heightSettings.isFullHeight ? 'isActiveActionBtn' : ''} ${classes.switcherForPrices}`}
                                                // title={myBasketTitle}
                                                name={"fullHeight"}
                                                onClick={setFullHeightForStore}>
                                                <FullHeightIcon/>
                                            </Button>
                                        </Box>
                                        <Box
                                            className={classes.shelvesScreenBox}
                                            // sx={{justifyContent: `flex-end!important`}}
                                        >
                                            <Button
                                                title={showHidePricesTitle}
                                                className={`${isShowPrice ? 'isActiveActionBtn' : ''} ${classes.switcherForPrices}`}
                                                // title={myBasketTitle}
                                                onClick={togglePricesForStore}>
                                                <SwitchPriceBtn/>
                                            </Button>
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid item xs>
                                    <Box
                                        className={classes.shelvesScreenBox}
                                        sx={{justifyContent: `flex-end`}}
                                    >
                                        <Button
                                            className={`${showBasket ? 'isActiveActionBtn' : ''} ${classes.shelvesHeaderButton}`}
                                            title={`${myBasketTitle} (${totalItems})`}
                                            onClick={onMyListClick}>
                                            <Box sx={{position: `relative`}} mx={`20px`}>
                                                <Basket/>
                                                <Box className={classes.numberOfMyListItems}>
                                                    <Typography sx={{
                                                        fontSize: `14px`,
                                                        lineHeight: `1`,
                                                        margin: `2px`,
                                                        textAlign: `center`
                                                    }}
                                                    >
                                                        {totalItems}
                                                    </Typography>
                                                </Box>

                                            </Box>
                                            <Typography>
                                                {myBasketTitle}
                                            </Typography>
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            }
            <Box className={`${classes.shelvesCategoriesFirstLVL2Wrapper}`} sx={{padding: 0}}>
                <Grid container alignItems={`center`} sx={{height: `100%`}}>
                    {
                        !isShowSearchInputShelvesScreen &&
                        <>
                            <Grid item xs>
                                <Box className={classes.shelvesScreenBox}
                                     sx={{
                                         justifyContent: `flex-start!important`,
                                         padding: `0 ${headerSectionPxNumber}px`
                                     }}>
                                    <Button onClick={toggleShelvesForStore}>
                                        {isCollapsedShelves ? <ExpandShelvesIcon/> : isHebrewStyle ? <HebCollapseShelvesIcon/> : <CollapseShelvesIcon/>}
                                    </Button>
                                    <Typography
                                        textAlign={'start'}
                                        fontSize={isMobileView ? 12 : 14}
                                        margin={"0 4px"}
                                        fontWeight={700}
                                    >
                                        {isCollapsedShelves ? expandText : collapseText}
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={!isMobileView ? 6 : 4} md={6} lg={8}>
                                {
                                    shelvesScreen.isDisplayCategories &&
                                    <>
                                        {
                                            !isMobileView ?
                                                <Box
                                                    className={`${classes.shelvesScreenBox} ${classes.shelvesCategoriesFirstLVL2Wrapper}`}
                                                    sx={{justifyContent: `center`, margin: isMobileView ? `0` : `0 32px`}}>
                                                    {localStateSecondaryCategoriesFromSelectedMainCategory.length > secondaryCategorySlidesShow &&
                                                        <Slider
                                                            ref={secondaryCategorySlider}
                                                            {...secondarySettings}
                                                        >
                                                            {secondaryCategoriesComp}
                                                        </Slider>
                                                    }
                                                    {localStateSecondaryCategoriesFromSelectedMainCategory.length <= secondaryCategorySlidesShow &&
                                                        <Box
                                                            sx={{
                                                                display: "flex"
                                                            }}
                                                        >
                                                            {secondaryCategoriesComp}
                                                        </Box>
                                                    }
                                                </Box> :
                                                <ShelvesCategorySelect isMainCategories={false}/>
                                        }
                                    </>
                                }
                            </Grid>
                        </>

                    }
                    {
                        isMobile && !isShowSearchInputShelvesScreen ?
                            <Grid item xs={3}>
                                <Box className={`${classes.shelvesSearchBtnWrapper}`} sx={{justifyContent: `flex-end`}}>
                                    <Button onClick={() => {
                                        showSearchInputShelvesScreen(!isShowSearchInputShelvesScreen)
                                    }}>
                                        <Search/>
                                    </Button>
                                </Box>
                            </Grid> :
                            <Grid item xs>
                                <Box sx={{mx: 2}}>
                                    <InputSearch
                                        onClearSearchInput={onClearSearchInput}
                                        onChangeSearchInput={onChangeSearchInput}
                                        valueSearchInput={searchValue}
                                        onSubmitSearchInput={onSubmitSearchInput}
                                        inputHeight={isMobileView ? `30px` : `100%`}
                                    />
                                </Box>
                            </Grid>
                    }
                </Grid>
            </Box>
            <Box ref={iframeWrapperRef} sx={{flex: `1 1 auto`, display: "flex", overflowY: "scroll"}}
                 className={classes.shelvesContentWrapper}>
                {/*log*/}
                {
                    shelvesScreen.isLoading ?
                        <Box className={classes.shelvesScreenBox}
                             sx={{height: `100%`, justifyContent: `center`, width: "100%"}}>
                            <PageSpinner/>
                        </Box> :
                        <Box sx={{height: `100%`, flex: "1 1 auto", display: "flex"}}>
                            {/*LAVIE: this is where you change canvas look and feel */}
                            {/*LAVIE: you can change hideLabel / hideColors values and see different design*/}
                            {/*you can switch true -> false in link /canvas.html?hideLabels=true&hideColors=true' */}
                            <iframe style={{border: `none`}} id="storeIframe"
                                    src={`/canvas.html?hideLabels=true&hideColors=true&showHtml=true`} width="100%"
                                    height="100%">

                            </iframe>
                        </Box>
                }
            </Box>
        </Box>
    )
}